import { useSearchCondition } from '@/providers/SearchConditionProvider';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useTeamPurchaseOrderPhases } from '@/hooks/api/0260_team_purchase_order_phases';
import { useBusinessPartners } from '@/hooks/api/0430_business_partners';
import { usePaymentMethods } from '@/hooks/api/0510_payment_methods';
import { usePaymentContexts } from '@/hooks/api/0511_payment_contexts';

export const PurchaseOrderSearchConditionTags = () => {
  const { purchaseOrderSearchCondition: searchCondition } = useSearchCondition();
  const isConditionExist = Object.values(searchCondition)
    .flat()
    .some((v) => v);

  if (!isConditionExist) return <></>;

  const { _w_, _t_, me, meTeamMember } = useCurrentTeamMember();
  const { data: phases } = useTeamPurchaseOrderPhases({ identifier: _w_!.identifier, team_id: _t_!.id });
  const { data: businessPartners } = useBusinessPartners({ identifier: _w_!.identifier, page: 1, per: 1000 });
  const { data: paymentMethods } = usePaymentMethods();
  const { data: paymentContexts } = usePaymentContexts();

  return (
    <div className="d-flex mb-4 align-items-center flex-wrap">
      {searchCondition.my_project && (
        <span className="badge rounded-pill badge-info mx-1 my-1">参加済プロジェクトのみ表示</span>
      )}
      {phases &&
        phases
          .filter((d) => searchCondition.team_purchase_order_phase_ids.includes(d.id))
          .map((d) => (
            <span key={`phase-tag-${d.id}`} className="badge rounded-pill badge-info mx-1 my-1">
              {d.label}
            </span>
          ))}
      {_t_!.team_members
        .filter((d) => searchCondition.user_ids.includes(d.user.id))
        .map((d) => (
          <span key={`user-tag-${d.user.id}`} className="badge rounded-pill badge-info mx-1 my-1">
            {d.user.user_account.name}
          </span>
        ))}
      {businessPartners &&
        businessPartners.business_partners
          .filter((d) => searchCondition.business_partner_ids.includes(d.id))
          .map((d) => (
            <span key={`bp-tag-${d.id}`} className="badge rounded-pill badge-info mx-1 my-1">
              {d.display_name}
            </span>
          ))}
      {paymentMethods &&
        paymentMethods
          .filter((d) => searchCondition.payment_method_ids.includes(d.id))
          .map((d) => (
            <span key={`pm-tag-${d.id}`} className="badge rounded-pill badge-info mx-1 my-1">
              {d.label}
            </span>
          ))}
      {paymentContexts &&
        paymentContexts
          .filter((d) => searchCondition.payment_context_ids.includes(d.id))
          .map((d) => (
            <span key={`pm-tag-${d.id}`} className="badge rounded-pill badge-info mx-1 my-1">
              {d.label}
            </span>
          ))}
      {searchCondition.archived ? (
        <span className="badge rounded-pill badge-primary mx-1 my-1">アーカイブ済プロジェクトを含める</span>
      ) : (
        <span className="badge rounded-pill badge-secondary mx-1 my-1">アーカイブ済プロジェクトを含めない</span>
      )}
    </div>
  );
};
